import { Component, Input } from '@angular/core';
import { ITable } from '../../../interfaces/table';
import { IFeatureCallWaiter, IFeatureCallWaiterAction } from '../../../interfaces/restaurant';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-table-statuses',
  templateUrl: './table-statuses.component.html',
  styleUrls: ['./table-statuses.component.scss']
})
export class TableStatusesComponent {
  @Input() table!: ITable;
  @Input() callWaiter: IFeatureCallWaiter | undefined = undefined;

  constructor(private readonly translate: TranslateService) {}

  public getActionLabel(action?: IFeatureCallWaiterAction): string | undefined {
    const currentLanguage = this.translate.currentLang || this.translate.defaultLang;

    return action?.translations?.[currentLanguage]
      || action?.translations?.['en-CA']
      || undefined;
  }
}
